/** Do not edit directly **/ /** Do not edit directly **/
/**
 * @prop --sy-skeleton-width: Skeleton width.
 * @prop --sy-skeleton-height: Skeleton height.
 * @prop --sy-skeleton-color: Skeleton color.
 * @prop --sy-skeleton-color-shimmer-travel: Skeleton color shimmer travel.
 * @prop --sy-skeleton-animation-duration: Skeleton animation duration.
 * @prop --sy-skeleton-gap: Skeleton gap.
 * @prop --sy-skeleton-border-radius: Skeleton border radius.
 * @prop --sy-skeleton-shimmer-length: Skeleton shimmer length.
 * @prop --sy-skeleton-pulse-opacity: Skeleton pulse opacity.
 * @prop --sy-skeleton-children-height: Skeleton children height.
 * @prop --sy-skeleton-children-width: Skeleton children width.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex-direction: var(--sy-skeleton-direction, column);
  gap: var(--sy-skeleton-gap, var(--sy-spacer-3));
  width: var(--sy-skeleton-width, 100%);
  height: var(--sy-skeleton-height, 100%);
}

span {
  display: block;
  width: var(--sy-skeleton-children-width, calc(100% / var(--sy-skeleton-count-width, 1)));
  height: var(--sy-skeleton-children-height, calc(100% / var(--sy-skeleton-count-height, 1)));
  pointer-events: none;
  user-select: none;
  background: var(--sy-skeleton-color, var(--sy-surface-dark));
  border-radius: var(--sy-skeleton-border-radius, 0);
  animation-duration: var(--sy-skeleton-animation-duration, 1s);
  animation-iteration-count: infinite;
}
span.shimmer {
  background: linear-gradient(to right, var(--sy-skeleton-color, var(--sy-surface-dark)) 8%, var(--sy-skeleton-color-shimmer-travel, var(--sy-surface-light)) calc(8% + var(--sy-skeleton-shimmer-length, 10%)), var(--sy-skeleton-color, var(--sy-surface-dark)) calc(8% + 2 * var(--sy-skeleton-shimmer-length, 10%)));
  background-size: 200% 200%;
  animation-name: shimmer;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
span.pulse {
  animation-name: pulse;
  animation-timing-function: ease-in;
}

@keyframes shimmer {
  0% {
    background-position: -100% 0;
  }
  100% {
    background-position: 100% 0;
  }
}
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: var(--sy-skeleton-pulse-opacity, 0.4);
  }
  100% {
    opacity: 1;
  }
}